import { createSlice } from "@reduxjs/toolkit";


const initialState = {

  user: null,
  userLang: "en",
  fcmToken: "",
  newNotification: false,
  viewprayerchange: false,
  selectedMethodAthan: {},
  activeTab:"desktop"
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {

    setUserLang(state, action) {
      state.userLang = action.payload;
    },
    setUserData(state, action) {
      state.user = action.payload;
    },
    setfcmToken(state, action) {
      state.fcmToken = action.payload;
    },
    setNewNotification(state, action) {
      state.newNotification = action.payload;
    },

    setUserviewprayerchange(state, action) {
      state.viewprayerchange = action.payload;
    },

    setMethodAthan(state, action) {
      state.selectedMethodAthan = action.payload;
    },

    setUserPopup(state, action) {
      state.user.data.showPopup = action.payload;
    },
    setStatus(state,action)
    {
      state.user.data.verificationStatus = action.payload
    },
    setResponsiveTab(state,action)
    {
      state.activeTab = action.payload
    }

    
  },
});

// Reducer
export default slice.reducer;
const actions = slice.actions;

export const setUserLang = (data) => (dispatch) => {
  console.log('data',data)
  dispatch(actions.setUserLang(data));
};

export const setUser = (data) => async (dispatch) => {
  dispatch(actions.setUserData(data));
};

export const setfcmToken = (data) => (dispatch) => {
  dispatch(actions.setfcmToken(data));
};

export const setNewNotification = (data) => (dispatch) => {
  dispatch(actions.setNewNotification(data));
};


export const setUserprayerchange = (data) => (dispatch) => {
  dispatch(actions.setUserviewprayerchange(data));
};


export const setselectedAthanMethod = (data) => (dispatch) => {
  dispatch(actions.setMethodAthan(data));
};


export const setShowPopup = (data) => (dispatch) => {
  dispatch(actions.setUserPopup(data));
};


export const setUserDocumentStatus = (data) => (dispatch) => {
  dispatch(actions.setStatus(data));
};

export const setResponsiveTab = (data) => (dispatch) => {
  dispatch(actions.setResponsiveTab(data));
};

